import {SET_CURRENT_CSV} from "../actions/user-assets.action.ts";


export interface  IUserAssetsReducerState {
    currentCsv: File | null;
}

const INITIAL_STATE: IUserAssetsReducerState = {
    currentCsv: null,
};

const userAssetsReducer = (state = INITIAL_STATE, action: any) => {
    switch (action.type) {
        case SET_CURRENT_CSV:
            return {...state, currentCsv: action.payload};
        default:
            return state;
    }
}

export default userAssetsReducer;
